import { Gift } from "lucide-react";
import { Card, Section } from "../Layout";
import { useI18n } from "../i18n";

export default function GiftSection() {
  const { t } = useI18n();

  return (
    <Section id="gift" eyebrow={t("gift.eyebrow")} title={t("gift.title")} icon={Gift}>
      <Card className="p-6 sm:p-8 text-center">
        <p className="mx-auto max-w-3xl text-sm sm:text-base leading-relaxed text-theme-text-muted">
          {t("gift.text")}
        </p>
      </Card>
    </Section>
  );
}